import React from "react";

const Contact = () => <h1 className="page-title">Contact Page</h1>;

export default Contact;